// -------------------------------------------------------------------------------

// PLEASE DO NOT EDIT THIS FILE, IT IS GENERATED AND WILL BE OVERWRITTEN:
// https://github.com/ccxt/ccxt/blob/master/CONTRIBUTING.md#how-to-contribute-code

// -------------------------------------------------------------------------------

import { implicitReturnType } from '../../base/types.js';
import { default as _Exchange } from '../../base/PredictionExchange.js';

interface Exchange {
    kalshiPublicGetEvents (params?: {}): Promise<implicitReturnType>;
    kalshiPublicGetEventsMultivariate (params?: {}): Promise<implicitReturnType>;
    kalshiPublicGetEventsFeeChanges (params?: {}): Promise<implicitReturnType>;
    kalshiPublicGetEventsEventTicker (params?: {}): Promise<implicitReturnType>;
    kalshiPublicGetEventsEventTickerMetadata (params?: {}): Promise<implicitReturnType>;
    kalshiPublicGetSeries (params?: {}): Promise<implicitReturnType>;
    kalshiPublicGetSeriesFeeChanges (params?: {}): Promise<implicitReturnType>;
    kalshiPublicGetSeriesSeriesTicker (params?: {}): Promise<implicitReturnType>;
    kalshiPublicGetSeriesSeriesTickerMarketsTickerCandlesticks (params?: {}): Promise<implicitReturnType>;
    kalshiPublicGetSeriesSeriesTickerEventsTickerCandlesticks (params?: {}): Promise<implicitReturnType>;
    kalshiPublicGetSeriesSeriesTickerEventsTickerForecastPercentileHistory (params?: {}): Promise<implicitReturnType>;
    kalshiPublicGetMarkets (params?: {}): Promise<implicitReturnType>;
    kalshiPublicGetMarketsTrades (params?: {}): Promise<implicitReturnType>;
    kalshiPublicGetMarketsOrderbooks (params?: {}): Promise<implicitReturnType>;
    kalshiPublicGetMarketsCandlesticks (params?: {}): Promise<implicitReturnType>;
    kalshiPublicGetMarketsTicker (params?: {}): Promise<implicitReturnType>;
    kalshiPublicGetMarketsTickerOrderbook (params?: {}): Promise<implicitReturnType>;
    kalshiPublicGetExchangeStatus (params?: {}): Promise<implicitReturnType>;
    kalshiPublicGetExchangeSchedule (params?: {}): Promise<implicitReturnType>;
    kalshiPublicGetExchangeAnnouncements (params?: {}): Promise<implicitReturnType>;
    kalshiPublicGetExchangeUserDataTimestamp (params?: {}): Promise<implicitReturnType>;
    kalshiPublicGetMilestones (params?: {}): Promise<implicitReturnType>;
    kalshiPublicGetMilestonesMilestoneId (params?: {}): Promise<implicitReturnType>;
    kalshiPublicGetStructuredTargets (params?: {}): Promise<implicitReturnType>;
    kalshiPublicGetStructuredTargetsStructuredTargetId (params?: {}): Promise<implicitReturnType>;
    kalshiPublicGetSearchFiltersBySport (params?: {}): Promise<implicitReturnType>;
    kalshiPublicGetSearchTagsByCategories (params?: {}): Promise<implicitReturnType>;
    kalshiPublicGetLiveDataBatch (params?: {}): Promise<implicitReturnType>;
    kalshiPublicGetLiveDataMilestoneMilestoneId (params?: {}): Promise<implicitReturnType>;
    kalshiPublicGetHistoricalMarkets (params?: {}): Promise<implicitReturnType>;
    kalshiPublicGetHistoricalMarketsTickerCandlesticks (params?: {}): Promise<implicitReturnType>;
    kalshiPublicGetHistoricalTrades (params?: {}): Promise<implicitReturnType>;
    kalshiPublicGetHistoricalCutoffTimestamps (params?: {}): Promise<implicitReturnType>;
    kalshiPublicGetMultivariateEventCollections (params?: {}): Promise<implicitReturnType>;
    kalshiPublicGetMultivariateEventCollectionsCollectionTicker (params?: {}): Promise<implicitReturnType>;
    kalshiPublicGetMultivariateEventCollectionsCollectionTickerLookup (params?: {}): Promise<implicitReturnType>;
    kalshiPublicGetIncentivePrograms (params?: {}): Promise<implicitReturnType>;
    kalshiPrivateGetPortfolioBalance (params?: {}): Promise<implicitReturnType>;
    kalshiPrivateGetPortfolioOrders (params?: {}): Promise<implicitReturnType>;
    kalshiPrivateGetPortfolioOrdersOrderId (params?: {}): Promise<implicitReturnType>;
    kalshiPrivateGetPortfolioOrdersOrderIdQueuePosition (params?: {}): Promise<implicitReturnType>;
    kalshiPrivateGetPortfolioOrdersQueuePositions (params?: {}): Promise<implicitReturnType>;
    kalshiPrivateGetPortfolioPositions (params?: {}): Promise<implicitReturnType>;
    kalshiPrivateGetPortfolioFills (params?: {}): Promise<implicitReturnType>;
    kalshiPrivateGetPortfolioSettlements (params?: {}): Promise<implicitReturnType>;
    kalshiPrivateGetPortfolioDeposits (params?: {}): Promise<implicitReturnType>;
    kalshiPrivateGetPortfolioWithdrawals (params?: {}): Promise<implicitReturnType>;
    kalshiPrivateGetPortfolioOrderGroups (params?: {}): Promise<implicitReturnType>;
    kalshiPrivateGetPortfolioOrderGroupsOrderGroupId (params?: {}): Promise<implicitReturnType>;
    kalshiPrivateGetPortfolioSummaryTotalRestingOrderValue (params?: {}): Promise<implicitReturnType>;
    kalshiPrivateGetPortfolioSubaccountsBalances (params?: {}): Promise<implicitReturnType>;
    kalshiPrivateGetPortfolioSubaccountsNetting (params?: {}): Promise<implicitReturnType>;
    kalshiPrivateGetPortfolioSubaccountsTransfers (params?: {}): Promise<implicitReturnType>;
    kalshiPrivateGetHistoricalFills (params?: {}): Promise<implicitReturnType>;
    kalshiPrivateGetHistoricalOrders (params?: {}): Promise<implicitReturnType>;
    kalshiPrivatePostPortfolioOrders (params?: {}): Promise<implicitReturnType>;
    kalshiPrivatePostPortfolioEventsOrders (params?: {}): Promise<implicitReturnType>;
    kalshiPrivatePostPortfolioOrdersBatched (params?: {}): Promise<implicitReturnType>;
    kalshiPrivatePostPortfolioOrdersOrderIdAmend (params?: {}): Promise<implicitReturnType>;
    kalshiPrivatePostPortfolioOrdersOrderIdDecrease (params?: {}): Promise<implicitReturnType>;
    kalshiPrivatePostPortfolioOrderGroupsCreate (params?: {}): Promise<implicitReturnType>;
    kalshiPrivatePostPortfolioSubaccounts (params?: {}): Promise<implicitReturnType>;
    kalshiPrivatePostPortfolioSubaccountsTransfer (params?: {}): Promise<implicitReturnType>;
    kalshiPrivatePostMultivariateEventCollectionsCollectionTicker (params?: {}): Promise<implicitReturnType>;
    kalshiPrivatePutPortfolioOrderGroupsOrderGroupIdReset (params?: {}): Promise<implicitReturnType>;
    kalshiPrivatePutPortfolioOrderGroupsOrderGroupIdTrigger (params?: {}): Promise<implicitReturnType>;
    kalshiPrivatePutPortfolioOrderGroupsOrderGroupIdLimit (params?: {}): Promise<implicitReturnType>;
    kalshiPrivatePutPortfolioSubaccountsNetting (params?: {}): Promise<implicitReturnType>;
    kalshiPrivatePutMultivariateEventCollectionsCollectionTickerLookup (params?: {}): Promise<implicitReturnType>;
    kalshiPrivateDeletePortfolioOrdersOrderId (params?: {}): Promise<implicitReturnType>;
    kalshiPrivateDeletePortfolioOrdersBatched (params?: {}): Promise<implicitReturnType>;
    kalshiPrivateDeletePortfolioEventsOrdersOrderId (params?: {}): Promise<implicitReturnType>;
    kalshiPrivateDeletePortfolioOrderGroupsOrderGroupId (params?: {}): Promise<implicitReturnType>;
    electionsPublicGetSearchSeries (params?: {}): Promise<implicitReturnType>;
}
abstract class Exchange extends _Exchange {}

export default Exchange
